import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJustifiTerminal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 522,
	height: 310,
	viewBox: "0 0 522 310",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 26.6501,
			y: 1,
			width: 136.511,
			height: 280.522,
			rx: 55,
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.9858 36.9102H151.092C159.377 36.9102 166.092 43.6259 166.092 51.9102V226.884C166.092 257.259 141.468 281.884 111.092 281.884H77.9858C47.6102 281.884 22.9858 257.259 22.9858 226.884V51.9102C22.9858 43.6259 29.7016 36.9102 37.9858 36.9102Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 43.6053,
			cy: 23.0851,
			r: 1.56501,
			fill: "#D9D9D9",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 94.9053,
			cy: 194.574,
			r: 1.56501,
			fill: "#D9D9D9",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84.5461,
			y: 277.288,
			width: 18.5201,
			height: 2.39716,
			rx: 1.19858,
			fill: "#D9D9D9",
			stroke: "#8E959E",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.8818 274.357H102.464C105.225 274.357 107.464 276.596 107.464 279.357V281.884H80.8818V279.357C80.8818 276.596 83.1204 274.357 85.8818 274.357Z",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 384.286,
			y: 1,
			width: 136.511,
			height: 280.522,
			rx: 55,
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 401.241,
			cy: 23.0851,
			r: 1.56501,
			fill: "#D9D9D9",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 452.541,
			cy: 194.574,
			r: 1.56501,
			fill: "#D9D9D9",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 388.783,
			cy: 111.761,
			r: 1.56501,
			fill: "#D9D9D9",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 515.567,
			cy: 111.761,
			r: 1.56501,
			fill: "#D9D9D9",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 442.182,
			y: 277.288,
			width: 18.5201,
			height: 2.39716,
			rx: 1.19858,
			fill: "#D9D9D9",
			stroke: "#8E959E",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M443.518 274.357H460.1C462.861 274.357 465.1 276.596 465.1 279.357V281.884H438.518V279.357C438.518 276.596 440.756 274.357 443.518 274.357Z",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 205.468,
			y: 1,
			width: 136.511,
			height: 280.522,
			rx: 55,
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.804 64.026H329.91C338.194 64.026 344.91 70.7417 344.91 79.026V254C344.91 284.375 320.286 309 289.91 309H256.804C226.428 309 201.804 284.375 201.804 254V79.026C201.804 70.7417 208.519 64.026 216.804 64.026Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 222.423,
			cy: 23.0851,
			r: 1.56501,
			fill: "#D9D9D9",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 273.723,
			cy: 194.574,
			r: 1.56501,
			fill: "#D9D9D9",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M264.7 301.473H281.282C284.043 301.473 286.282 303.712 286.282 306.473V309H259.7V306.473C259.7 303.711 261.938 301.473 264.7 301.473Z",
			fill: "white",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 260.166,
			y: 307.069,
			width: 25.6501,
			height: 2.93144,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-20-inside-1_2009_34969",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M499.078 161.962H406.737V155.366H395.012V39.5745H509.338V155.366H499.078V161.962Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M499.078 161.962H406.737V155.366H395.012V39.5745H509.338V155.366H499.078V161.962Z",
			fill: "#A1A8B0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M499.078 161.962V163.962H501.078V161.962H499.078ZM406.737 161.962H404.737V163.962H406.737V161.962ZM406.737 155.366H408.737V153.366H406.737V155.366ZM395.012 155.366H393.012V157.366H395.012V155.366ZM395.012 39.5745V37.5745H393.012V39.5745H395.012ZM509.338 39.5745H511.338V37.5745H509.338V39.5745ZM509.338 155.366V157.366H511.338V155.366H509.338ZM499.078 155.366V153.366H497.078V155.366H499.078ZM499.078 161.962V159.962H406.737V161.962V163.962H499.078V161.962ZM406.737 161.962H408.737V155.366H406.737H404.737V161.962H406.737ZM406.737 155.366V153.366H395.012V155.366V157.366H406.737V155.366ZM395.012 155.366H397.012V39.5745H395.012H393.012V155.366H395.012ZM395.012 39.5745V41.5745H509.338V39.5745V37.5745H395.012V39.5745ZM509.338 39.5745H507.338V155.366H509.338H511.338V39.5745H509.338ZM509.338 155.366V153.366H499.078V155.366V157.366H509.338V155.366ZM499.078 155.366H497.078V161.962H499.078H501.078V155.366H499.078Z",
			fill: "#6F7780",
			mask: "url(#path-20-inside-1_2009_34969)"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 413.833,
			y1: 150.236,
			x2: 413.833,
			y2: 155.366,
			stroke: "#6F7780"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 411.135,
			y1: 152.668,
			x2: 416.265,
			y2: 152.668,
			stroke: "#6F7780"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 419.929,
			y1: 152.668,
			x2: 425.059,
			y2: 152.668,
			stroke: "#6F7780"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M410.265 208.4C413.026 208.4 415.265 210.638 415.265 213.4V225.584C415.265 228.345 413.026 230.584 410.265 230.584H384.286V208.4H410.265Z",
			fill: "#DCEBFE",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M389.012 208.4C391.773 208.4 394.012 210.638 394.012 213.4V225.584C394.012 228.345 391.773 230.584 389.012 230.584H384.286V208.4H389.012Z",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M407.937 208.4V230.584H384.286V208.4H407.937Z",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 447.312,
			y: 40.5745,
			width: 15.5887,
			height: 36.8416,
			fill: "#DCEBFE",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M454.399 70.3288C454.79 70.7194 455.423 70.7194 455.814 70.3288L462.178 63.9649C462.568 63.5744 462.568 62.9412 462.178 62.5507C461.787 62.1601 461.154 62.1601 460.763 62.5507L455.106 68.2075L449.45 62.5507C449.059 62.1601 448.426 62.1601 448.035 62.5507C447.645 62.9412 447.645 63.5744 448.035 63.9649L454.399 70.3288ZM455.106 47.6359H454.106V69.6217H455.106H456.106V47.6359H455.106Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M418.284 218.582C417.899 218.978 417.907 219.611 418.302 219.996L424.747 226.279C425.142 226.664 425.775 226.656 426.161 226.261C426.546 225.865 426.538 225.232 426.143 224.846L420.414 219.262L425.999 213.534C426.384 213.138 426.376 212.505 425.981 212.12C425.585 211.734 424.952 211.742 424.566 212.138L418.284 218.582ZM440.984 219L440.971 218L418.987 218.28L419 219.28L419.013 220.28L440.997 220L440.984 219Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M272.676 274.771C273.457 275.552 274.723 275.552 275.504 274.771L288.232 262.043C289.013 261.262 289.013 259.996 288.232 259.215C287.451 258.434 286.185 258.434 285.404 259.215L274.09 270.529L262.776 259.215C261.995 258.434 260.729 258.434 259.948 259.215C259.167 259.996 259.167 261.262 259.948 262.043L272.676 274.771ZM274.09 207.4H272.09V273.357H274.09H276.09V207.4H274.09Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.9929,
			cy: 24.9173,
			r: 9.99291,
			fill: "#DCEBFE",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.308 29L9.892 19.2H12.034L15.604 29H13.602L10.956 21.356L8.296 29H6.308ZM7.89 26.774L8.394 25.304H13.378L13.868 26.774H7.89Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 189.811,
			cy: 24.9173,
			r: 9.99291,
			fill: "#DCEBFE",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.966 30V20.2H189.984C190.665 20.2 191.239 20.3074 191.706 20.522C192.173 20.7367 192.523 21.0354 192.756 21.418C192.999 21.7914 193.12 22.2254 193.12 22.72C193.12 23.2147 193.013 23.63 192.798 23.966C192.583 24.302 192.299 24.5634 191.944 24.75C191.599 24.9274 191.216 25.03 190.796 25.058L191.02 24.904C191.468 24.9227 191.865 25.044 192.21 25.268C192.565 25.4827 192.84 25.772 193.036 26.136C193.241 26.5 193.344 26.8967 193.344 27.326C193.344 27.8487 193.218 28.3107 192.966 28.712C192.714 29.1134 192.35 29.4307 191.874 29.664C191.398 29.888 190.815 30 190.124 30H185.966ZM187.856 28.46H189.816C190.329 28.46 190.726 28.3434 191.006 28.11C191.286 27.8767 191.426 27.5407 191.426 27.102C191.426 26.6634 191.281 26.3227 190.992 26.08C190.703 25.828 190.301 25.702 189.788 25.702H187.856V28.46ZM187.856 24.288H189.676C190.171 24.288 190.544 24.176 190.796 23.952C191.057 23.728 191.188 23.4107 191.188 23C191.188 22.5987 191.057 22.286 190.796 22.062C190.544 21.8287 190.166 21.712 189.662 21.712H187.856V24.288Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 368.629,
			cy: 24.9173,
			r: 9.99291,
			fill: "#DCEBFE",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M368.362 30.168C367.382 30.168 366.537 29.958 365.828 29.538C365.128 29.1087 364.587 28.516 364.204 27.76C363.831 26.9947 363.644 26.1127 363.644 25.114C363.644 24.1154 363.831 23.2334 364.204 22.468C364.587 21.7027 365.128 21.1054 365.828 20.676C366.537 20.2467 367.382 20.032 368.362 20.032C369.547 20.032 370.518 20.326 371.274 20.914C372.03 21.502 372.501 22.3327 372.688 23.406H370.63C370.509 22.8834 370.252 22.4774 369.86 22.188C369.477 21.8894 368.973 21.74 368.348 21.74C367.769 21.74 367.27 21.88 366.85 22.16C366.439 22.4307 366.122 22.818 365.898 23.322C365.674 23.8167 365.562 24.414 365.562 25.114C365.562 25.8047 365.674 26.402 365.898 26.906C366.122 27.41 366.439 27.7974 366.85 28.068C367.27 28.3387 367.769 28.474 368.348 28.474C368.973 28.474 369.477 28.3387 369.86 28.068C370.243 27.788 370.495 27.4007 370.616 26.906H372.688C372.501 27.9234 372.03 28.7214 371.274 29.3C370.518 29.8787 369.547 30.168 368.362 30.168Z",
			fill: "#146EF5"
		})
	]
});
export default SvgJustifiTerminal;
